import { Radio, RadioProps } from "@mui/material";

import "./style.scss";
import { ReactComponent as RadioButtonIcon } from "../../assets/radio-button.icon.svg";
import { ReactComponent as RadioButtonCheckedIcon } from "../../assets/radio-button-checked.icon.svg";

export const TivaRadioButton = (props: RadioProps) => {
    return (
        <Radio
            className="custom-radio-buttom"
            disableRipple
            color="default"
            checkedIcon={<RadioButtonCheckedIcon />}
            icon={<RadioButtonIcon />}
            {...props}
        />
    );
};
